




import { Vue, Component, Prop } from "vue-property-decorator";

import CommitteesList from "@share/committees/committees-list/CommitteesList.vue";
import { CommitteeModelInterface } from "@api/models/interfaces/committees/CommitteeModelInterface";
import { EventType } from "@share/common/types/enums/EventType";

@Component({ components: { CommitteesList } })
export default class CommitteesListView extends Vue {
    @Prop() committee: CommitteeModelInterface | null;
    @Prop() activeSectionType: EventType;
}
